import { gql } from '@apollo/client';

export const fetchBIReportAccessQuery = gql`
  query getBIReportAccess($oktaId: String!, $clubId: String) {
    access: getBIReportAccess(oktaId: $oktaId, clubId: $clubId)
  }
`;
